import { isNil } from "lodash";

import { AgentGroup } from "shared/model/AgentGroup";

import {
    ApiKeyLocationIn, ApiKeyResponse, ApiPolicyApiKeyGroupView, ApiPolicyListFilterQuery, ApiPolicyRequestLoggingOptionView,
    ApiPolicyTargetEndpointView, ApiPolicyView, PolicyEndpointMethod, ThrottlingTimeUnit
} from "apiPolicies/model/ApiPolicy";

export const API_POLICIES_SUB_PATH = 'ApiPolicies';

export const getApiPoliciesPath = (environment: string, agentGroup: string, policyId?: string | number) => `/${environment}/${agentGroup}/${API_POLICIES_SUB_PATH}${policyId ? `/${policyId}` : ''}`;

export const NEW_API_POLICY_ID = 'New';

export const getNewTargetedEndpoint = (): ApiPolicyTargetEndpointView => ({
    method: PolicyEndpointMethod.ALL,
    path: '/api',
    requestLimit: undefined,
    requestLimitWindowInMinutes: undefined
});

export const getNewApiPolicyView = (): ApiPolicyView => ({
    apiKeyName: "x-api-key",
    apiKeyLocation: ApiKeyLocationIn.Header,
    targetEndpoints: [getNewTargetedEndpoint()]
});

export const getFilterAsQueryParam = (filter?: string) => {
    if (!filter || filter === '') {
        return undefined;
    }
    const filterWrapper: ApiPolicyListFilterQuery = { filter };
    return filterWrapper as { [key: string]: string };
};

export const getRecordAsOptions = (en: Record<string, string | number>) => Object.entries(en).map((e) => ({ label: e[0], value: e[1] }));

export const replaceAtIndex = (index: number, item?: unknown, array?: unknown[]) => {
    if (!array || array.length <= index) {
        return undefined;
    }

    return [
        ...array.slice(0, index),
        ...(item ? [item] : []),
        ...array.slice(index + 1)
    ];
};

export const isThrottlingDisabled = (requestLimitWindowInMinutes?: ThrottlingTimeUnit) => isNil(requestLimitWindowInMinutes) || requestLimitWindowInMinutes === ThrottlingTimeUnit.Disabled;

export const getAvailableApiKeys = (allApiKeys: ApiKeyResponse[], apiKeyGroups?: ApiPolicyApiKeyGroupView[]) => {
    if (!apiKeyGroups || apiKeyGroups.length === 0) {
        return allApiKeys;
    }

    const assignedApiKeys = new Set(apiKeyGroups
        .flatMap((groups) => groups.apiPolicyApiKeyGroupAssignments?.map((assignment) => assignment.apiKey.id))
        .filter((id) => id));

    return allApiKeys.filter((apiKey) => !assignedApiKeys.has(apiKey.id));
};

export const getAvailableAgentGroupsForRequestLogging = (allAgentGroups: AgentGroup[], loggingOptions?: ApiPolicyRequestLoggingOptionView[]) => {
    const crossplatAgentGroups = allAgentGroups.filter((ag) => ag.isCrossPlatform);

    if (!loggingOptions || loggingOptions.length === 0) {
        return crossplatAgentGroups;
    }

    const assignedAgentGroupNames = new Set(loggingOptions.flatMap((option) => option.deployments?.map(x=>x.agentGroupName) || []));

    return crossplatAgentGroups.filter((ag) => !assignedAgentGroupNames.has(ag.name));
};